<template>
    <b-navbar toggleable="lg" type="dark" class="navbar-default" fixed>
        <b-navbar-toggle target="nav_collapse" />
        <b-navbar-brand to="/landing">
            <b-img class="nav-img" :src="require('../../assets/sioLogo.png')"></b-img>
        </b-navbar-brand>
        <b-collapse is-nav id="nav_collapse">
            <b-navbar-nav>
                <b-nav-item to="/my-tracks">My Tracks</b-nav-item>
                <b-nav-item v-if="!isAdmin" to="/set">My Set</b-nav-item>
                <b-nav-item v-if="isAdmin" to="/admin/requests">Requests</b-nav-item>
                <b-nav-item v-if="isAdmin" to="/admin/tracks">Tracks</b-nav-item>
                <b-nav-item v-if="isAdmin" to="/admin/playlists">Playlists</b-nav-item>
                <b-nav-item @click="doLogout" href="#">Logout</b-nav-item>
            </b-navbar-nav>
        </b-collapse>
    </b-navbar>
</template>

<script>
    export default {
        name: "NavBar",
        data() {
          return {
              isAdmin: false
          }
        },
        methods: {
            doLogout() {
                this.$store.dispatch('setAuthStatus', false).then(() => {
                    localStorage.removeItem('token');
                    this.$router.replace('/');
                });
            }
        },
        mounted() {
            this.isAdmin = this.$store.state.isAdmin && this.$store.state.user.email === 'admin';
        }
    }
</script>

<style scoped>
    .navbar-default {
        background-color: rgba(235, 63, 36,100) !important;
        color: #FFFFFF;
    }

    .nav-img {
        height:40px;
        position: absolute;
        margin-left: -70px !important;
        left: 50%;
        display: block;
        top: 8px;
    }
</style>
